module.exports = __webpack_public_path__ + "static/img/maps.ff37309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maps.png
// module id = cBA6
// module chunks = 0